module.exports = __webpack_public_path__ + "img/advantage2Orange.84d31197.png";